import React, { Component } from 'react';
import JobsTable from '../jobs/jobs-table.jsx';
export default class CustomersJobsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      url: props.url || null,
      jobs:[],
      isLoading:true,
      hasMore:true,
      page:1
    };
    this.handleScroll = this.handleScroll.bind(this);
  }
  componentDidMount() {
    if (this.state.isLoading) {
      this.getCustomerJobs();
    }
  }
  componentWillMount() {
      window.addEventListener(
        'scroll',
        this.handleScroll
      );
  }
  handleScroll() {
    if ((window.innerHeight + document.scrollingElement.scrollTop + 10
        ) >= document.documentElement.offsetHeight) {
          if(this.state.hasMore){
            this.setState({
              isLoading: true
            });
            this.getCustomerJobs();
            }
    }
  }
  getCustomerJobs(){
    return fetch(
      this.state.url+'?page='+this.state.page,
      {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        }
      }
    ).then((responseText) => {
      let response = responseText.json();
      response.then((dataJson) => {
        if(dataJson.jobs.data.length == 0){
          this.setState({hasMore: false});
        }
        this.setState({
          jobs: [
            ...this.state.jobs,
            ...dataJson.jobs.data,
          ],
          // jobs: dataJson.jobs.data,
          isLoading: false,
          page:dataJson.jobs.current_page + 1
        });
      });
    });
  }
  render() {
    let Jobs = [];
    return (
      <div className="col-md-12">
        <h3>Customer Jobs</h3>
        { (this.state.jobs.length > 0 )?
            <JobsTable
                url={this.state.url}
                jobs={this.state.jobs}
                noCategoryLabels={true}
                message_if_none='No Jobs found. Add one to see it here.'
                driverScreen={false}
                customerAllJobsPage={true}
            /> : null
        }
        {
          this.state.isLoading ?
          (<div className="loading-box" style={{margin:'0 auto'}}>
            <span className="add-loading-text">
              <i className="fa fa-spinner fa-pulse"></i>
            </span>
          </div>) :
            null
        }
        {(this.state.hasMore) ?
          null
          :
          <div className="text-center no-more">
            <h1>
              No more jobs.
            </h1>
          </div>
        }
      </div>
    );
  }
}
